import * as React from 'react';
import * as classNames from 'classnames';
import { observer } from 'mobx-react';
import { CSSTransitionGroup } from 'react-transition-group';
import { BubblingMethod } from './../../../../common/helpers/bubbling';

// Styles
const s = require('./DeleteConfirmation.css');
const trashCanIcon = require('./../../assets/trash-can-icon.svg');
const closeIcon = require('./../../assets/cross-orange-sign.svg');

// Props
interface IDeleteConfirmationProps {
    className?: string;
    show: boolean;
    cancelLabel?: string;
    confirmationLabel?: string;
    onCancel: () => void;
    onConfirmDeletion: () => void;
}

// Component
@observer
export class DeleteConfirmation extends React.Component<IDeleteConfirmationProps, {}> {
    static get defaultProps(): IDeleteConfirmationProps {
        return {
            className: null,
            show: false,
            cancelLabel: 'Cancel',
            confirmationLabel: 'Confirm',
            onCancel: null,
            onConfirmDeletion: null
        };
    }

    private windowEvents: void[] = [];

    componentWillUpdate(nextProps: IDeleteConfirmationProps) {
        if (this.props.show === false && nextProps.show === true) {
            this.setEvents();
        } else if (this.props.show === true && nextProps.show === false) {
            this.clearEvents();
        }
    }

    public render() {
        return (
            <CSSTransitionGroup
                component="div"
                transitionName="cart-tooltip"
                transitionAppear={true}
                transitionEnter={true}
                transitionLeave={true}
                transitionAppearTimeout={400}
                transitionEnterTimeout={400}
                transitionLeaveTimeout={300}
            >
                {(this.props.show) && (
                    <div className={classNames(s.tooltip, this.props.className)} ref={this.referenceTooltipContainer}>
                        <button
                            className={s.cancelDialogButton}
                            onClick={this.handleCancellation}
                        >
                            <strong>{this.props.cancelLabel}</strong>
                            <img src={closeIcon} alt="" />
                        </button>
                        <button
                            className={s.deleteDialogButton}
                            onClick={this.handleDeleteConfirmation}
                        >
                            <strong>{this.props.confirmationLabel}</strong>
                            <img src={trashCanIcon} alt="" />
                        </button>
                    </div>
                )}
            </CSSTransitionGroup>
        );
    }

    private tooltipContainer: HTMLDivElement = null;
    private referenceTooltipContainer = (ref) => this.tooltipContainer = ref;

    private handleDocumentClick = (e: Event) => {
        if (this.tooltipContainer && BubblingMethod.isInsideOtherElement(e.target as HTMLElement, this.tooltipContainer)) {
            // Do nothing
        } else {
            this.props.onCancel();
        }
    }

    private handleCancellation = () => {
        this.props.onCancel();
    }

    private handleDeleteConfirmation = () => {
        this.props.onConfirmDeletion();
    }

    private setEvents = () => {
        document.body.addEventListener('click', this.handleDocumentClick, false);
    }

    private clearEvents = () => {
        this.windowEvents.map((ev) => {
            document.body.removeEventListener('click', this.handleDocumentClick);
        });

        this.windowEvents = [];
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/popup/DeleteConfirmation.tsx